import { getAllSavedItems } from "../../../js/api/saved-items";
import { addToCompare, getComparedItems, handleAddToCompare } from '../../../js/api/compare';
import { closeQuickAction, handleOtherActions, handleViewMap } from '../../../js/components/other-actions';
import { handleSaveEvent } from "../../../js/components/save-community";
import { addToastMessage } from '../../../js/components/toast';
import { openLeaseTerm } from '../../../js/components/lease-term';
import { getViewComparisonLink } from '../../../js/modules/utilities';
import { addToCompareHandler } from '../../../js/components/quick-view';

const SAVED_ITEMS_CONTAINER_ID = 'saved-items-container';
const SAVED_ITEMS_COMMUNITIES_LIST_ID = 'saved-items-communities-list';
const SAVED_ITEMS_FLOORPLANS_LIST_ID = 'saved-items-floorplans-list';
const COMMUNITIES_ARROW_LEFT_ID = 'saved-items-communities-arrow-left';
const COMMUNITIES_ARROW_RIGHT_ID = 'saved-items-communities-arrow-right';
const FLOORPLAN_ARROW_LEFT_ID = 'saved-items-floorplan-arrow-left';
const FLOORPLAN_ARROW_RIGHT_ID = 'saved-items-floorplan-arrow-right';
const SAVED_ITEMS_COMMUNITIES_EMPTY_ID = 'saved-items-communities-empty';
const SAVED_ITEMS_FLOORPLANS_EMPTY_ID = 'saved-items-floorplans-empty';

export const savedItems = () => {

  const savedItemsContainer = document.getElementById(SAVED_ITEMS_CONTAINER_ID);
  const communitiesList = document.getElementById(SAVED_ITEMS_COMMUNITIES_LIST_ID);
  const communityArrowLeft = document.getElementById(COMMUNITIES_ARROW_LEFT_ID);
  const communityArrowRight = document.getElementById(COMMUNITIES_ARROW_RIGHT_ID);

  const floorplansList = document.getElementById(SAVED_ITEMS_FLOORPLANS_LIST_ID);
  const floorplanArrowLeft = document.getElementById(FLOORPLAN_ARROW_LEFT_ID);
  const floorplanArrowRight = document.getElementById(FLOORPLAN_ARROW_RIGHT_ID);
  const communitiesEmptyArea = document.getElementById(SAVED_ITEMS_COMMUNITIES_EMPTY_ID);
  const floorplansEmptyArea = document.getElementById(SAVED_ITEMS_FLOORPLANS_EMPTY_ID);
  let savedItemsBackBtn;

  if (savedItemsContainer) {
    savedItemsBackBtn = savedItemsContainer.querySelector('#saved-items-back');
  }

  const communitiesArrowCounter = {
    value: 0,
  };

  const floorplansArrowCounter = {
    value: 0,
  };

  const onSavedItemsContainerClickHandler = (e) => {
    e.stopPropagation();
  }

  const addToCompareClickListener = (e, communityEl, community) => {
    e.stopPropagation();
    const id = e.currentTarget && e.currentTarget.dataset && e.currentTarget.dataset.id;
    if (id) {
      handleAddToCompare(e)
        .then((res) => {
          if (res !== false) {
            const addToCompareBtn = communityEl.querySelector('.plus-btn');
            if (addToCompareBtn) {
              addToCompareBtn.remove();
            }
            const actionsDiv = communityEl.querySelector('.saved-items-content__communities-list__item-actions');
            if (actionsDiv) {
              const div = document.createElement('div');
              div.classList.add('added-to-compare');
              div.innerHTML = `
              <svg><use xlink:href="#checkmark"></use></svg>
              <span>Added to Compare</span>
            `;
              actionsDiv.appendChild(div);
            }
            const props = {
              body: `${community.PropertyName} added to your Compare list`,
              imgSrc: community.Image,
            };
            const comparisonPageUrl = getViewComparisonLink();
            if (comparisonPageUrl) {
              props.btnText = 'View';
              props.btnHref = comparisonPageUrl;
            }
            addToastMessage(props);
          }
        });
    }
  }

  const initCommunities = (communities = []) => {
    communitiesArrowCounter.value = 0;
    if (communitiesList) {
      communitiesList.scrollLeft = 0;
      if (communitiesList.children) {
        [...communitiesList.children].forEach(child => {
          child.remove();
        })
      }
      communities.forEach((community) => {
        const div = document.createElement('div');
        div.classList.add('saved-items-content__communities-list__item');
        div.innerHTML = `
          <a href="${community.Url}">
            <img src=${community.Image} alt="">
            ${community.Neighborhood ?
            `<h6>${community.Neighborhood}</h6>`
            : ''}
            <p>${community.PropertyName}</p>
          </a>
          <div class="saved-items-content__communities-list__item-actions">
            <a class="apt-fav saved saved-rounded" data-id=${community.Id} href="#save">
              <svg class="saved-items"><use xlink:href="#saved-items"></use></svg>
            </a>
            ${community.IsCompare ?
            `
              <div class="added-to-compare">
                <svg><use xlink:href="#checkmark"></use></svg>
                <span>Added to Compare</span>
              </div>
            ` :
            `
              <div class="plus-btn" data-id=${community.Id} href="#compare">
                <svg><use xlink:href="#plus-thin"></use></svg>
              </div>
            `
          }
          </div>
        `;
        communitiesList.appendChild(div);
        div.querySelector('.apt-fav')
          .addEventListener('click', (e) => {
            handleSaveEvent(e);
            div.classList.add('remove');
            div.addEventListener('transitionend', () => {
              div.remove();
              renderCommunityArrows();
              checkIfEmpty();
              // decreaseCounter();
            });
          })
        const addToCompareBtn = div.querySelector('.plus-btn');
        if (addToCompareBtn) {
          addToCompareBtn.addEventListener('click', (e) => addToCompareClickListener(e, div, community));
        }
      });
    }
    if (communitiesEmptyArea) {
      if (communities.length > 0) {
        communitiesEmptyArea.classList.remove('show');
      } else {
        communitiesEmptyArea.classList.add('show');
      }
    }
  }

  const initFloorplans = (floorplans = []) => {
    floorplansArrowCounter.value = 0;
    if (floorplansList) {
      if (floorplansList.children) {
        [...floorplansList.children].forEach(child => {
          child.remove();
        })
      }
      floorplans.forEach((floorplan) => {
        const div = document.createElement('div');
        div.classList.add('saved-items-content__floorplans-list__item');
        if (floorplan.IsAvailable === true) {
          div.innerHTML = `
          <a href="${floorplan.FloorplanUrl}">
            <img src="${floorplan.Image}" alt="">
            <h6>${(floorplan.Neighborhood !== null && floorplan.Neighborhood !== undefined) ? floorplan.Neighborhood : ''}</h6>
            <p>${floorplan.PropertyName}</p>
            <div class="saved-items-content__floorplans-list__item-details">
              <h4>Unit #${floorplan.FloorplanName}</h4>
              <div class="floorplans-studio-price">
                <span class="floorplans-type">${floorplan.UnitType}</span>
                <span class="floorplans-price"><sup>$</sup>${floorplan.Price}</span>
              </div>
              <div class="floorplans-move-in-date">
                <span class="floorplans-move-in">Move-in</span>
                <span class="floorplans-date-period">${floorplan.MoveInDate}</span>
              </div>
            </div>
          </a>
          <div class="saved-items-content__floorplans-list__item-actions">
            <a class="apt-fav saved saved-rounded" data-id="${floorplan.Id}" data-cookie="true" href="#save">
              <svg class="saved-items"><use xlink:href="#saved-items"></use></svg>
            </a>
            <div class="other other-rounded" data-id="${floorplan.Id}">
              <svg class="other-actions"><use xlink:href="#other-actions"></use></svg>
              <div class="other-actions-dropdown">
                <ul>
                  <li><a class="leasing-terms_list_item" data-iframe-url="${floorplan.LeasingInfoUrl}"><svg class="copy"><use xlink:href="#copy"></use></svg>Lease info</a></li>
                  <li><a class="open-view-map-modal" data-map-link="${floorplan.PropertyMapLink}" href="#"><svg class="pin"><use xlink:href="#pin"></use></svg> View on Map</a></li>
                  <li><a href="tel:${floorplan.Phone}"><svg class="phone"><use xlink:href="#phone"></use></svg> Call Us</a></li>
                  <li><a href="${floorplan.FloorplanUrl}"><svg class="phone"><use xlink:href="#floorplan"></use></svg> View Floor Plan Details</a></li>
                </ul>
              </div>
            </div>
          </div>
        `;
        }
        else {
          div.innerHTML = `
          <a href="${floorplan.Url}">
            <img src="${floorplan.Image}" alt="">
            <h6>${(floorplan.Neighborhood !== null && floorplan.Neighborhood !== undefined) ? floorplan.Neighborhood : ''}</h6>
            <p>${floorplan.PropertyName}</p>
            <div class="saved-items-content__floorplans-list__item-details">
              <div class="floorplans-studio-price">
                <span class="floorplans-type">${floorplan.UnitType}</span>
              </div>
            </div>
          </a>
          <div class="saved-items-content__floorplans-list__item-actions">
            <a class="apt-fav saved saved-rounded" data-id="${floorplan.Id}" data-cookie="true" href="#save">
              <svg class="saved-items"><use xlink:href="#saved-items"></use></svg>
            </a>
          </div>
        `;
        }

        div.querySelector('.apt-fav').addEventListener('click', (e) => {
          handleSaveEvent(e);
          div.classList.add('remove');
          div.addEventListener('transitionend', () => {
            div.remove();
            renderFloorplansArrows();
            checkIfEmpty();
          });
        });

        if (floorplan.IsAvailable === true) {
          div.querySelector('.other').addEventListener('click', (e) => {
            e.stopPropagation();
            let x = e.clientX;
            let y = e.clientY;
            handleOtherActions(e);
            const otherAction = e.currentTarget.querySelector('.active');
            if (otherAction) {
              otherAction.style.left = `${x}px`;
              otherAction.style.position = 'fixed';
              otherAction.style.top = `${y - 280}px`;
            }
          });

          div.querySelector('.leasing-terms_list_item').addEventListener('click', (e) => {
            openLeaseTerm(e);
          });

          div.querySelector(".open-view-map-modal").addEventListener('click', (e) => {
            handleViewMap(e);
          });
        }

        if (savedItemsContainer) {
          savedItemsContainer.addEventListener('click', closeQuickAction);
        }

        floorplansList.appendChild(div);
      });
      floorplansList.scrollLeft = 0;
    }
    if (floorplansEmptyArea) {
      if (floorplans.length > 0) {
        floorplansEmptyArea.classList.remove('show');
      } else {
        floorplansEmptyArea.classList.add('show');
      }
    }
  }

  const checkIfEmpty = () => {
    if (communitiesList && communitiesList.children && communitiesList.children.length === 0) {
      communitiesEmptyArea.classList.add('show');
    }
    if (floorplansList && floorplansList.children && floorplansList.children.length === 0) {
      floorplansEmptyArea.classList.add('show');
    }
  }

  const savedItemsOpenHandler = async () => {
    const savedItems = await getAllSavedItems();
    initCommunities(savedItems.communities);
    initFloorplans(savedItems.floorplans);
    renderCommunityArrows();
    renderFloorplansArrows();
  }

  const onCommunityArrowLeftClick = (e) => {
    e.stopPropagation();
    if (communitiesList) {
      communitiesList.scrollBy({
        top: 0,
        left: -152,
        behavior: 'smooth',
      });
    }
  }

  const onCommunityArrowRightClick = (e) => {
    e.stopPropagation();
    if (communitiesList) {
      communitiesList.scrollBy({
        top: 0,
        left: 152,
        behavior: 'smooth',
      });
    }
  }

  const onFloorplansArrowLeftClick = (e) => {
    e.stopPropagation();
    if (floorplansList) {
      floorplansList.scrollBy({
        top: 0,
        left: -152,
        behavior: 'smooth',
      });
    }
  }

  const onFloorplansArrowRightClick = (e) => {
    e.stopPropagation();
    if (floorplansList) {
      floorplansList.scrollBy({
        top: 0,
        left: 152,
        behavior: 'smooth',
      });
    }
  }

  const renderCommunityArrows = () => {
    if (communitiesList) {
      const canScrollLeft = communitiesList.scrollLeft > 0;
      const canScrollRight = communitiesList.scrollLeft !== communitiesList.scrollWidth - communitiesList.clientWidth;
      if (canScrollLeft && communityArrowLeft) {
        communityArrowLeft.classList.add('active')
      } else if (communityArrowLeft) {
        communityArrowLeft.classList.remove('active');
      }
      if (canScrollRight && communityArrowRight) {
        communityArrowRight.classList.add('active');
      } else if (communityArrowRight) {
        communityArrowRight.classList.remove('active');
      }
    }
  }

  const renderFloorplansArrows = () => {
    if (floorplansList) {
      const canScrollLeft = floorplansList.scrollLeft > 0;
      const canScrollRight = floorplansList.scrollLeft !== floorplansList.scrollWidth - floorplansList.clientWidth;
      if (canScrollLeft && floorplanArrowLeft) {
        floorplanArrowLeft.classList.add('active')
      } else if (floorplanArrowLeft) {
        floorplanArrowLeft.classList.remove('active');
      }
      if (canScrollRight && floorplanArrowRight) {
        floorplanArrowRight.classList.add('active');
      } else if (floorplanArrowRight) {
        floorplanArrowRight.classList.remove('active');
      }
    }

  }

  const closeSavedItemsContainer = () => {
    if (savedItemsContainer) {
      savedItemsContainer.classList.remove('show');
    }
  }

  const init = () => {
    if (savedItemsContainer) {
      savedItemsContainer.addEventListener('click', onSavedItemsContainerClickHandler);
      savedItemsContainer.addEventListener('savedItemsOpened', savedItemsOpenHandler);
    }
    if (communityArrowLeft) {
      communityArrowLeft.addEventListener('click', onCommunityArrowLeftClick)
    }
    if (communityArrowRight) {
      communityArrowRight.addEventListener('click', onCommunityArrowRightClick)
    }
    if (floorplanArrowLeft) {
      floorplanArrowLeft.addEventListener('click', onFloorplansArrowLeftClick)
    }
    if (floorplanArrowRight) {
      floorplanArrowRight.addEventListener('click', onFloorplansArrowRightClick)
    }
    if (communitiesList) {
      communitiesList.addEventListener('scrollend', renderCommunityArrows);
    }
    if (floorplansList) {
      floorplansList.addEventListener('scrollend', renderFloorplansArrows);
    }
    if (savedItemsBackBtn) {
      savedItemsBackBtn.addEventListener('click', closeSavedItemsContainer);
    }
  }

  init();
}



// WEBPACK FOOTER //
// ./src/templates/components/saved-items/saved-items.js